import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
// import telegram from "/assets/landingpage/telegram.svg";
import { landingMotionInView } from "@/utils/landingMotion";
import { FaTelegramPlane } from "react-icons/fa";

const COMMUNITY_FEATURES = [
  {
    icon: "/assets/landingpage/aim.svg",
    label: "Real-Time Setups",
  },
  {
    icon: "/assets/landingpage/thunder.svg",
    label: "Real-Time Updates",
  },
  {
    icon: "/assets/landingpage/graph.svg",
    label: "Real-Time Insights",
  },
  {
    icon: "/assets/landingpage/lock.svg",
    label: "Trader-Only Access",
  },
] as const;

function CommunityDivider() {
  return (
    <div
      aria-hidden
      className="hidden h-8 w-px shrink-0 bg-gradient-to-b from-transparent via-white/60 to-transparent lg:block"
    />
  );
}

function MobileCommunityDividers() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 lg:hidden">
      <div className="absolute left-1/2 top-4 bottom-4 w-px -translate-x-1/2 bg-gradient-to-b from-transparent via-white/70 to-transparent" />
      <div className="absolute left-4 right-4 top-1/2 h-px -translate-y-1/2 bg-gradient-to-r from-transparent via-white/45 to-transparent" />
    </div>
  );
}

function CommunityFeature({
  icon,
  label,
}: {
  icon: string;
  label: string;
}) {
  return (
    <div className="flex min-w-0 items-center gap-3 px-2 py-4 text-left md:px-3 lg:px-0 lg:py-0">
      <img
        src={icon}
        alt="feature icon"
        className="h-9 w-9 shrink-0 object-contain md:h-7 md:w-7 lg:h-6 lg:w-6"
        loading="lazy"
      />
      <p className="font-nexa text-sm md:text-lg leading-tight text-white xl:text-base">
        {label}
      </p>
    </div>
  );
}

export default function CommunityCard() {
  const { t } = useTranslation();

  return (
    <div className="relative w-full h-auto px-6 md:px-0">
       <motion.div
      className="relative font-nexa z-20 w-full overflow-hidden max-w-7xl mx-auto p-[1px] rounded-[32px] "
      style={{
        background:
          "linear-gradient(-90deg, #DBD633 0%, #9ED473 50%, #1CCDE6 100%)",
      }}
      {...landingMotionInView}
    >
      <div className="px-5 pb-6 pt-8 md:px-12 md:py-14 rounded-[32px] bg-[url('/assets/landingpage/bannerbg.png')] bg-cover bg-center bg-no-repeat bg-black" >
        <p className="text-white text-center md:text-left text-xl md:text-[28px] font-medium">Join the URFX Telegram Community</p>
        <h5 className=" md:max-w-[400px] lg:max-w-[600px] text-white tracking-tight text-center md:text-left text-[32px] md:text-5xl font-bold font-nexa">
          
          <span className=" text-gradient font-creato">
            {t("Get Real-Time Setups & ")} {" "}
          </span>
          Trader Insights
        </h5>
        <p className="text-white text-center md:text-left text-base md:text-lg font-normal max-w-[650px] pt-4">Access trade ideas, real-time market updates, and exclusive trader-only insights before the crowd moves.</p>
        <div
          className="pt-7"
        >
          <button
            onClick={() => window.open("https://t.me/urfxchannel", "_blank")}
            className="btn-gradient-left font-nexa w-full md:w-fit min-w-[160px] rounded-[10px] px-1 md:px-6 py-2.5 text-sm md:text-lg font-bold"

          >
            <FaTelegramPlane size={22} className="text-[#1B92D1] mr-2" />
            {t("Join the URFX Telegram Community")}
          </button>
        </div>

        <div className="relative mt-5 grid max-w-[590px] grid-cols-2 md:mt-7 lg:flex lg:flex-row lg:items-center lg:gap-4">
          <MobileCommunityDividers />
          {COMMUNITY_FEATURES.map((feature, index) => (
            <div key={feature.label} className="contents">
              {index > 0 && <CommunityDivider />}
              <CommunityFeature
                icon={feature.icon}
                label={t(feature.label)}
              />
            </div>
          ))}
        </div>

        <img src="/assets/landingpage/bannermob.png" alt="telegram logo" className="w-full h-auto md:hidden" />
      </div>
    </motion.div>
    </div>
  )
}